// extracted by mini-css-extract-plugin
export var trust = "index-module--trust--84b92";